/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClasseHoraireCoherenceGridDto } from './FcbClasseHoraireCoherenceGridDto';
import {
    FcbClasseHoraireCoherenceGridDtoFromJSON,
    FcbClasseHoraireCoherenceGridDtoFromJSONTyped,
    FcbClasseHoraireCoherenceGridDtoToJSON,
} from './FcbClasseHoraireCoherenceGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClasseHoraireCoherenceGridDtoPaginatedResults
 */
export interface FcbClasseHoraireCoherenceGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseHoraireCoherenceGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClasseHoraireCoherenceGridDto>}
     * @memberof FcbClasseHoraireCoherenceGridDtoPaginatedResults
     */
    results?: Array<FcbClasseHoraireCoherenceGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClasseHoraireCoherenceGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClasseHoraireCoherenceGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClasseHoraireCoherenceGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseHoraireCoherenceGridDtoPaginatedResultsFromJSON(json: any): FcbClasseHoraireCoherenceGridDtoPaginatedResults {
    return FcbClasseHoraireCoherenceGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClasseHoraireCoherenceGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseHoraireCoherenceGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClasseHoraireCoherenceGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClasseHoraireCoherenceGridDtoPaginatedResultsToJSON(value?: FcbClasseHoraireCoherenceGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClasseHoraireCoherenceGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

